import React from "react";
import { useTrackElement } from "@edreamsodigeo/frontend-core";
import { Box } from "@edreamsodigeo/prisma-design-system";
import { FIND_BY_BOOKING } from "./config/datameshIds";
const FindMyBookingByReferenceErrorMessage = ({
  text,
  isValidationError
}) => {
  const displayTrackingRef = useTrackElement(["display"], isValidationError ? FIND_BY_BOOKING.VALIDATION_ERROR : FIND_BY_BOOKING.ERROR);
  return /*#__PURE__*/React.createElement(Box, {
    ref: displayTrackingRef
  }, text);
};
export default FindMyBookingByReferenceErrorMessage;